"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicationRequest_DispenseRequest = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_MedicationRequest_InitialFill_1 = require("./RTTI_MedicationRequest_InitialFill");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Reference_1 = require("./RTTI_Reference");
exports.RTTI_MedicationRequest_DispenseRequest = t.recursion('IMedicationRequest_DispenseRequest', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        initialFill: RTTI_MedicationRequest_InitialFill_1.RTTI_MedicationRequest_InitialFill,
        dispenseInterval: RTTI_Duration_1.RTTI_Duration,
        validityPeriod: RTTI_Period_1.RTTI_Period,
        numberOfRepeatsAllowed: RTTI_unsignedInt_1.RTTI_unsignedInt,
        _numberOfRepeatsAllowed: RTTI_Element_1.RTTI_Element,
        quantity: RTTI_Quantity_1.RTTI_Quantity,
        expectedSupplyDuration: RTTI_Duration_1.RTTI_Duration,
        performer: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_MedicationRequest_DispenseRequest.js.map